var Seats = function () {
    var map = null;
    var bounds = typeof boundsMinLat !== 'undefined' ? [
        [boundsMinLat, boundsMinLng],
        [boundsMaxLat, boundsMaxLng]
    ] : [[0, 0], [100, 100]];
    // var maxHeight = maxHeight;
    var interval = null;
    var minTime = null;
    var selectedSeats = [];
    var colors = {
        available: {
            stroke: '#333',
            text: '#333'
        },
        booked: {
            fill: '#999',
            stroke: '#666',
            text: 'white'
        },
        selected: {
            fill: '#EF3F3E',
            stroke: '#EF3F3E',
            text: 'white'
        },
        scene: {
            fill: '#1a1a1a',
            stroke: '#333',
            text: 'white'
        }
    };
    var animationClass = 'animate-pulse';

    function setMapHeightFromBounds() {
        var mapDiv = document.getElementById('map');
        if (!mapDiv) return;

        // Sprawdź czy zmienne są zdefiniowane
        if (typeof minHeight === 'undefined' || typeof maxHeight === 'undefined') {
            return;
        }

        // Wylicz proporcje z bounds
        var latRange = bounds[1][0] - bounds[0][0];
        var lngRange = bounds[1][1] - bounds[0][1];
        var aspectRatio = latRange / lngRange;

        // Pobierz szerokość kontenera
        var containerWidth = mapDiv.offsetWidth;

        // Wylicz wysokość na podstawie proporcji
        var calculatedHeight = Math.round(containerWidth * aspectRatio);

        calculatedHeight = Math.max(minHeight, Math.min(calculatedHeight, maxHeight));

        mapDiv.style.height = calculatedHeight + 'px';
    }

    var initMap = function () {
        // Sprawdź czy zmienne są zdefiniowane
        if (typeof zoomSnap === 'undefined' || typeof zoomDelta === 'undefined' ||
            typeof minZoom === 'undefined' || typeof maxZoom === 'undefined') {
            console.warn('Map configuration variables are not defined');
            return;
        }

        map = L.map('map', {
            crs: L.CRS.Simple,
            zoomSnap: zoomSnap,
            zoomDelta: zoomDelta,
            wheelPxPerZoomLevel: 120,
            zoomControl: typeof isMapZoomControlEnabled !== 'undefined' ? isMapZoomControlEnabled : true,
            minZoom: minZoom,
            // maxBounds: bounds,
            // maxBoundsViscosity: 0.3,
            maxZoom: maxZoom
        });

        // map.dragging.disable();
        // map.touchZoom.disable();
        // map.doubleClickZoom.disable();
        // map.scrollWheelZoom.disable();
    };

    var initSeats = function () {
        // Sprawdź czy zmienne są zdefiniowane
        if (typeof seats === 'undefined' || !seats) {
            console.warn('Seats data is not defined');
            return;
        }

        initSelectedSeats();

        for (let i = 0; i < seats.length; i++) {
            initSeat(seats[i]);
        }

        // Oblicz bounds z marginesem dla swobodnego przesuwania przy zoom
        let latRange = bounds[1][0] - bounds[0][0];
        let lngRange = bounds[1][1] - bounds[0][1];

        // Dodaj 50% marginesu z każdej strony
        let margin = {
            lat: latRange * 0.5,
            lng: lngRange * 0.5
        };

        let expandedBounds = [
            [bounds[0][0] - margin.lat, bounds[0][1] - margin.lng],
            [bounds[1][0] + margin.lat, bounds[1][1] + margin.lng]
        ];

        map.setMaxBounds(expandedBounds);
        map.options.maxBoundsViscosity = 0.3; // Miękkie ograniczenie
    };

    var initSelectedSeats = function () {
        minTime = blockedSeatsExpirationTime;

        if (savedSelectedSeats != null && typeof savedSelectedSeats != 'undefined') {
            let savedSelectedSeatsTmp = savedSelectedSeats.map((seat) => {
                return {
                    id: seat.id,
                    name: seat.name,
                    price: seat.price,
                    quantity: seat.quantity || 1,
                    type: seat.type,
                    block_expiration_date: seat.block_expiration_date
                }
            });

            savedSelectedSeatsTmp.forEach((seat) => {
                selectedSeats.push(seat);
            });
        }
    }

    var initSeat = function (seat) {
        let isSelected = selectedSeats.some((selectedSeat) => selectedSeat.id === seat.id);
        let tooltipText = seat.tooltip;
        let seatMarker;
        let isAvailable = seat.isAvailable !== false;
        let isBooked = seat.isBooked || !isAvailable;

        if (seat.type === 'pool') {
            let fillColor = !isAvailable ? '#cccccc' : (isSelected ? colors.selected.fill : seat.color);
            let strokeColor = isSelected ? colors.selected.stroke : (isAvailable ? colors.available.stroke : '#999999');

            seatMarker = L.polygon(seat.geometry, {
                fillColor: fillColor,
                fillOpacity: isAvailable ? 0.7 : 0.4,
                color: strokeColor,
                weight: 0.5
            }).addTo(map);

            if (seat.name || seat.number) {
                let center = seatMarker.getBounds().getCenter();
                let textColor = !isAvailable ? '#666666' : (isSelected ? colors.selected.text : colors.available.text);
                let labelText = seat.name || seat.number;

                addPolygonLabel(center, labelText, textColor, seat.id, seatMarker.getBounds());
            }
        } else {
            let seatColor = isAvailable ? seat.color : '#cccccc';
            let seatIcon = createSVGIcon(seatColor, seat.number, isBooked, isSelected, isAvailable);
            seatMarker = L.marker([seat.lat, seat.lng], {
                icon: seatIcon
            }).addTo(map);
        }

        seatMarker.isSelected = isSelected;
        seatMarker.id = seat.id;
        seatMarker.originalColor = seat.color;
        seatMarker.name = seat.name;
        seatMarker.price = seat.price;
        seatMarker.eventId = seat.eventId;
        seatMarker.isBooked = isBooked;
        seatMarker.number = seat.number;
        seatMarker.type = seat.type;
        seatMarker.isAvailable = isAvailable;

        seatMarker.bindTooltip(tooltipText, {
            direction: 'bottom',
            offset: new L.Point(0, 8),
            permanent: false,
            sticky: false,
        });

        let tooltipTimeout;

        seatMarker.on('mouseover', function (e) {
            closeAllTooltips();
            clearTimeout(tooltipTimeout);
            tooltipTimeout = setTimeout(() => {
                this.openTooltip();
            }, 300);
        });

        seatMarker.on('mouseout', function (e) {
            clearTimeout(tooltipTimeout);
            this.closeTooltip();
        });

        if (isAvailable && !seat.isBooked) {
            seatMarker.on('click', function (e) {
                // RÓŻNE ZACHOWANIE DLA POOL vs INDIVIDUAL
                if (seat.type === 'pool') {
                    handlePoolSeatClick(this, seat);
                } else {
                    handleIndividualSeatClick(this, seat);
                }
            });
        }
    }

    var createSVGIcon = function (color, label = null, isBooked = false, isSelected = false, isAvailable = true) {
        let fillColor = !isAvailable ? '#cccccc' : (isBooked ? colors.booked.fill : (isSelected ? colors.selected.fill : color));
        let strokeColor = !isAvailable ? '#999999' : (isBooked ? colors.booked.stroke : (isSelected ? colors.selected.stroke : colors.available.stroke));
        let textColor = !isAvailable ? '#666666' : (isBooked ? colors.booked.text : (isSelected ? colors.selected.text : colors.available.text));

        let svgString = `
            <svg width="16" height="16" viewBox="0 0 16 16">
                <rect x="1" y="1" width="14" height="14" fill="${fillColor}" stroke="${strokeColor}" stroke-width="0.5" rx="1"/>
                ${label ? `<text x="8" y="11" text-anchor="middle" font-size="8" class="font-primary font-light" fill="${textColor}">${label}</text>` : ''}
            </svg>
        `;

        return L.divIcon({
            html: svgString,
            iconSize: [16, 16],
            iconAnchor: [8, 8],
            className: 'svg-seat-icon'
        });
    };

    // Obsługa zwykłych miejsc (bez zmian)
    var handleIndividualSeatClick = function (seatElement, seat) {
        if (seatElement.isSelected) {
            unblockSeats(seatElement.id, seatElement.eventId).then((success) => {
                updateSeatAppearance(seatElement, false);
                seatElement.isSelected = false;
                flushMessage(success.message);
            }).catch((error) => {
                flushMessage(error.message, true);
            });
            return;
        }

        if (selectedSeats.length >= maxSeatsPerOrder) {
            flushMessage('Możesz zarezerwować maksymalnie 10 miejsc');
            return;
        }

        blockSeats(seatElement.id, seatElement.eventId).then((success) => {
            updateSeatAppearance(seatElement, true);
            seatElement.isSelected = true;
            flushMessage(success.message);
        }).catch((error) => {
            flushMessage(error.message, true);
        });
    };

    var handlePoolSeatClick = function (seatElement, seat) {
        if (seatElement.isSelected) {
            // Odblokuj pool
            unblockSeats(seatElement.id, seatElement.eventId).then((success) => {
                updateSeatAppearance(seatElement, false);
                seatElement.isSelected = false;
                flushMessage(success.message);
            }).catch((error) => {
                flushMessage(error.message, true);
            });
            return;
        }

        // Pokaż modal z wyborem ilości
        showQuantityModal(seat, function (quantity) {
            blockSeats(seatElement.id, seatElement.eventId, quantity).then((success) => {
                updateSeatAppearance(seatElement, true);
                seatElement.isSelected = true;
                seatElement.selectedQuantity = quantity;
                flushMessage(success.message);
            }).catch((error) => {
                flushMessage(error.message, true);
            });
        });
    };

    var showQuantityModal = function (seat, callback) {
        let maxQuantity = Math.min(seat.ticketsLeft, maxSeatsPerOrder - selectedSeats.length);

        if (maxQuantity <= 0) {
            flushMessage('Brak dostępnych miejsc lub osiągnięto limit', true);
            return;
        }

        // Wypełnij opcje select
        let select = document.getElementById('seat-quantity-select');
        select.innerHTML = '';
        for (let i = 1; i <= maxQuantity; i++) {
            select.innerHTML += `<option value="${i}">${i}</option>`;
        }

        // Pokaż modal
        document.getElementById('seat-quantity-modal').classList.remove('hidden');

        // Event handlers
        document.getElementById('seat-quantity-confirm').onclick = function () {
            let quantity = parseInt(document.getElementById('seat-quantity-select').value);
            hideQuantityModal();
            callback(quantity);
        };

        document.getElementById('seat-quantity-cancel').onclick = function () {
            hideQuantityModal();
        };
    };

    var hideQuantityModal = function () {
        document.getElementById('seat-quantity-modal').classList.add('hidden');

        // Wyczyść event handlery
        document.getElementById('seat-quantity-confirm').onclick = null;
        document.getElementById('seat-quantity-cancel').onclick = null;
    };

    var updateSeatAppearance = function (seatElement, isSelected) {
        seatElement.isSelected = isSelected;
        
        let isAvailable = seatElement.isAvailable !== false;

        if (seatElement.type === 'pool') {
            let fillColor = !isAvailable ? '#cccccc' : (isSelected ? colors.selected.fill : seatElement.originalColor);
            let strokeColor = !isAvailable ? '#999999' : (isSelected ? colors.selected.stroke : colors.available.stroke);

            seatElement.setStyle({
                fillColor: fillColor,
                color: strokeColor,
                weight: 0.5,
                fillOpacity: isAvailable ? 0.7 : 0.4
            });
        } else {
            seatElement.setIcon(createSVGIcon(
                seatElement.originalColor, 
                seatElement.number, 
                seatElement.isBooked, 
                isSelected,
                isAvailable
            ));
        }
    };

    var addPolygonLabel = function (position, text, textColor, seatId, polygonBounds) {
        // Oblicz szerokość na podstawie polygonu
        let polygonWidth = polygonBounds.getEast() - polygonBounds.getWest();
        let labelWidth = Math.max(polygonWidth * 0.9, 80); // 90% szerokości polygonu, min 80px

        let labelHtml = `
        <div style="color: ${textColor};
                    font-size: 14px;
                    text-align: center;
                    font-family: var(--font-primary);
                    pointer-events: none;
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;">
            ${text}
        </div>
    `;

        L.marker(position, {
            icon: L.divIcon({
                html: labelHtml,
                iconSize: [labelWidth, 20],
                iconAnchor: [labelWidth / 2, 10],
                className: 'polygon-seat-label'
            }),
            interactive: false
        }).addTo(map);
    };

    var setDefaultBounds = function () {
        map.fitBounds(bounds);
    }

    var initActions = function () {
        document.getElementById('reset-zoom').addEventListener('click', setDefaultBounds);
    }

    var printSelectedSeats = function () {
        let selectedSeatsContainer = document.getElementById('selected-seats');

        if (typeof selectedSeatsContainer === 'undefined' || selectedSeatsContainer === null) {
            return;
        }

        document.getElementById('selected-seats').innerHTML = selectedSeats
            .map((seat) =>
                `<li id="seat_${seat.id}">
                    <div>
                        <span>
                            <span>${seat.quantity > 1 ? seat.quantity + ' x ' : ''}</span>
                            ${seat.name}
                        </span>
                        <span>
                            ${seat.price} zł
                        </span>
                    </div>
                    <input type="hidden" name="seats[${seat.id}]" value="${seat.quantity}"/>
                </li>`
            )
            .join('');

        document.getElementById('selected-seats-total-price').innerHTML = parseFloat(selectedSeats.reduce((sum, item) => sum + parseFloat(item.price * item.quantity), 0)).toFixed(2) + " zł";

        // Update scroll button counter
        let scrollBtnCount = document.getElementById('scroll-btn-seats-count');
        if (scrollBtnCount) {
            let totalSeatsCount = selectedSeats.reduce((sum, item) => sum + parseInt(item.quantity), 0);
            scrollBtnCount.textContent = totalSeatsCount;
        }
    }

    var initDoneEvents = function () {
        map.on('zoomend', function () {
            displayDebugInfo();
        });

        map.on('dragstart', function () {
            closeAllTooltips();
        });

        map.on('moveend', function () {
            displayDebugInfo();
        });

        map.on('resize', function () {
            displayDebugInfo();
        });

        setTimeout(displayDebugInfo, 100);
    }

    var closeAllTooltips = function () {
        map.eachLayer(function (layer) {
            if (layer.getTooltip && layer.getTooltip()) {
                layer.closeTooltip();
            }
        });
    }

    var blockSeats = function (seatId, eventId, quantity = 1) {
        if (blockSeatsUrl == undefined && blockSeatsUrl == '') {
            console.log('Can not block seats');
            return Promise.reject()
        }

        return new Promise(function (resolve, reject) {
            $.ajax({
                type: "POST",
                url: blockSeatsUrl,
                data: {
                    seat_id: seatId,
                    event_id: eventId,
                    quantity: quantity
                },
                async: true,
                success: function (response) {
                    let $res = JSON.parse(response);
                    setSelectedSeats($res.blocked_seats);
                    resolve($res);
                },
                error: function (error) {
                    let $error = JSON.parse(error.responseText);
                    reject($error);
                },
            })
        });
    }

    var unblockSeats = function (seatId, eventId) {
        if (unblockSeatsUrl == undefined && unblockSeatsUrl == '') {
            console.log('Can not unblock seats');
            return Promise.reject()
        }

        return new Promise(function (resolve, reject) {
            $.ajax({
                type: "POST",
                url: unblockSeatsUrl,
                data: {
                    seat_id: seatId,
                    event_id: eventId
                },
                async: true,
                success: function (response) {
                    let $res = JSON.parse(response);
                    setSelectedSeats($res.blocked_seats);
                    resolve($res);
                },
                error: function (error) {
                    let $error = JSON.parse(error.responseText);
                    reject($error);
                }
            });
        });

    }

    var flushMessage = function (message, isErrorMessage = false) {
        if (message == '' || message == null || typeof message == 'undefined') {
            return;
        }

        if (isErrorMessage) {
            $("#flushErrorMessage").text(message).fadeIn().delay(3000).fadeOut();
            return;
        }

        $("#flushSuccessMessage").text(message).fadeIn().delay(3000).fadeOut();
    }

    var setSelectedSeats = function (seatsToSet) {
        if (seatsToSet == undefined || seatsToSet == null) {
            return;
        }

        selectedSeats = seatsToSet;

        let individualSeats = selectedSeats.filter(seat => seat.type === 'individual');

        // Update minTime based on selected seats
        if (individualSeats.length > 0) {
            let seats = individualSeats;
            minTime = seats.reduce((min, seat) => {
                return new Date(seat.block_expiration_date) < new Date(min) ? seat.block_expiration_date : min;
            }, individualSeats[0].block_expiration_date);
        }

        initCountdown();
        printSelectedSeats();
    }

    var initCountdown = function () {
        clearInterval(interval);
        var $counterContainer = $(`#blocked-seats-counter`);
        var $counter = $(`#blocked-seats-counter .counter`);

        let individualSeats = selectedSeats
            ? selectedSeats.filter(seat => seat.type === 'individual')
            : [];

        if (individualSeats.length === 0) {
            $counterContainer.hide();
            $counter.text('00:00');
            console.log('No selected seats found. Retrying in 1 second...');
            setTimeout(initCountdown, 1000); // Spróbuj ponownie po 1 sekundzie
            return;
        }

        if (minTime === null || typeof minTime === 'undefined') {
            return;
        }

        var targetTime = new Date(minTime).getTime();

        interval = setInterval(() => {
            var now = new Date().getTime();
            var timeRemaining = targetTime - now;

            if (timeRemaining < 30000 && $counterContainer.hasClass(animationClass) === false) {
                $counterContainer.addClass(animationClass);
            } else if (timeRemaining > 30000 && $counterContainer.hasClass(animationClass)) {
                $counterContainer.removeClass(animationClass);
            }

            if (timeRemaining < 0) {
                clearInterval(interval);
                $counterContainer.hide();
                $counter.text('00:00');
                setSelectedSeats([]);

                if (timeoutRedirectUrl !== null && typeof timeoutRedirectUrl !== 'undefined') {
                    setTimeout(() => window.location.href = timeoutRedirectUrl, 1000);
                }

                return;
            }

            // Oblicz minuty i sekundy
            var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
            var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

            // Formatowanie odliczania
            $counter.text(`${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`);
            $counterContainer.slideDown();
        }, 1000);
    }

    var initMapElements = function () {
        // Sprawdź czy zmienne są zdefiniowane
        if (typeof mapElements === 'undefined' || !mapElements) {
            return;
        }

        mapElements.forEach(element => {
            switch (element.type) {
                case 'rectangle':
                    addRectangleElement(element);
                    break;
                case 'label':
                    addElementLabel(element.latlng, element.label, element.labelStyle);
                    break;
            }
        });
    };

    var addRectangleElement = function (element) {
        let rectangle = L.rectangle(element.bounds, {
            ...element.style,
            interactive: element.interactive
        }).addTo(map);

        if (element.label) {
            let center = rectangle.getBounds().getCenter();
            addElementLabel(center, element.label, element.labelStyle);
        }
    };

    var addElementLabel = function (position, label, style) {
        let labelHtml = `
        <div style="color: ${style?.color || 'black'};
                    font-size: ${style?.fontSize || '12px'};
                    font-weight: ${style?.fontWeight || 'normal'};
                    font-family: ${style?.fontFamily || 'var(--font-primary)'};
                    text-align: center;
                    line-height: 30px;">
            ${label}
        </div>
    `;

        L.marker(position, {
            icon: L.divIcon({
                html: labelHtml,
                iconSize: [100, 30],
                iconAnchor: [50, 15],
                className: 'map-element-label'
            }),
            interactive: false
        }).addTo(map);
    };

    var displayDebugInfo = function () {
        if (!isDebugEnabled) {
            return;
        }

        let debugElement = document.getElementById('debug-info');
        if (!debugElement) {
            debugElement = document.createElement('div');
            debugElement.id = 'debug-info';
            document.getElementById('map').appendChild(debugElement);
        }

        let currentBounds = map.getBounds();
        let zoom = map.getZoom();
        let center = map.getCenter();
        let mapSize = map.getSize();

        let latRange = currentBounds.getNorth() - currentBounds.getSouth();
        let lngRange = currentBounds.getEast() - currentBounds.getWest();

        debugElement.innerHTML = `
        <strong>DEBUG INFO</strong><br>
        <br>
        <strong>Aktualny widok:</strong><br>
        Zoom: ${zoom.toFixed(2)}<br>
        Centrum: [${center.lat.toFixed(0)}, ${center.lng.toFixed(0)}]<br>
        <br>
        <strong>Bounds (widoczny obszar):</strong><br>
        Północ: ${currentBounds.getNorth().toFixed(0)}<br>
        Południe: ${currentBounds.getSouth().toFixed(0)}<br>
        Wschód: ${currentBounds.getEast().toFixed(0)}<br>
        Zachód: ${currentBounds.getWest().toFixed(0)}<br>
        <br>
        <strong>Zakres współrzędnych:</strong><br>
        Szerokość (lng): ${lngRange.toFixed(0)} jednostek<br>
        Wysokość (lat): ${latRange.toFixed(0)} jednostek<br>
        <br>
        <strong>Rozmiar kontenera:</strong><br>
        Szerokość: ${mapSize.x}px<br>
        Wysokość: ${mapSize.y}px<br>
        <br>
        <strong>Skala (px na jednostkę):</strong><br>
        X: ${(mapSize.x / lngRange).toFixed(2)} px/jednostka<br>
        Y: ${(mapSize.y / latRange).toFixed(2)} px/jednostka<br>
        <br>
        <strong>Bounds miejsc:</strong><br>
        [${bounds[0][0].toFixed(0)}, ${bounds[0][1].toFixed(0)}] - [${bounds[1][0].toFixed(0)}, ${bounds[1][1].toFixed(0)}]<br>
        Miejsca: ${seats.length}
    `;
    };

    var fitMapHeight = function () {
        setMapHeightFromBounds();

        if (map) {
            map.invalidateSize();
            setDefaultBounds();
        }
    }

    return {
        init: function () {
            setMapHeightFromBounds();
            initMap();
            initSeats();
            initMapElements();
            initActions();
            initDoneEvents();
            setDefaultBounds();
            printSelectedSeats();
            initCountdown();

            window.addEventListener('resize', fitMapHeight);
            document.addEventListener('DOMContentLoaded', fitMapHeight);
        },
        initCountdown: function () {
            initSelectedSeats();
            initCountdown();
        }
    };
}();

if (typeof (initSeats) != "undefined" && initSeats) {
    Seats.init();
}

if (typeof (initSeatsCountdown) != "undefined" && initSeatsCountdown) {
    Seats.initCountdown();
}
